let Spinner = () => {
    return (
        <div className="loading__ico loading__ico--show">
            <img src="/images/spinner-third-light.svg" alt="" />
        </div>
    );
}

export default Spinner;